import { observer } from 'mobx-react-lite'
import React, { type FC, useState } from 'react'
import classNames from 'classnames'
import { Dropdown } from 'shared/ui'
import { MeetingsContent } from 'widgets/Meetings/ui/MeetingsContent'
import { type MeetingsProps } from 'widgets/Meetings/store/meetingsStore'
import styles from './styles.module.scss'

export const MeetingsIconAction: FC<MeetingsProps> = observer((props) => {
  const [isNecessaryReconnect, setIsNecessaryReconnect] = useState(false)
  const allowedIntegrationsList = ['hubspot', 'calendly']
  const { integrations } = props

  const filteredIntegrations =
    integrations?.filter((integration) => allowedIntegrationsList.includes(integration.key)) || []

  if (filteredIntegrations.length === 0) {
    return null
  }

  return (
    <Dropdown
      ariaLabel={'MeetingsIconAction'}
      placement={'top-start'}
      tooltipProps={{
        label: 'Meetings',
        placement: 'top',
      }}
      sizeTriggerButton={'medium'}
      variantTriggerButton={'icon'}
      icon={'calendar'}
      typeButton={'icon-button'}
      customComponent={(onCloseMenu) => (
        <div
          className={classNames(styles.dropdownWrapper, {
            [styles.full]: isNecessaryReconnect,
          })}
        >
          <MeetingsContent
            onCloseMenu={onCloseMenu}
            onNecessaryReconnect={setIsNecessaryReconnect}
            {...props}
            integrations={filteredIntegrations}
          />
        </div>
      )}
    />
  )
})
